import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, List, Header, Segment } from 'semantic-ui-react';

const FooterBlock = () => (
  <Segment inverted vertical style={{ padding: '3em 0em' }}>
    <Container>
      <Grid divided inverted stackable>
        <Grid.Row>
          <Grid.Column width={3}>
            <Header inverted as="h4" content="Navigation" />
            <List link inverted>
              <List.Item as={Link} to="/">
                Home
              </List.Item>
              <List.Item as={Link} to="/About">
                About Us
              </List.Item>
              <List.Item as={Link} to="/Contact">
                Contact Us
              </List.Item>
            </List>
          </Grid.Column>
          <Grid.Column width={3}>
            <Header inverted as="h4" content="Social" />
            <List link inverted>
              <List.Item as="a" href="http://www.facebook.com/tribevibe">
                Facebook
              </List.Item>
              <List.Item as="a" href="http://www.twitter.com/gotribevibe">
                Twitter
              </List.Item>
            </List>
          </Grid.Column>
          <Grid.Column width={7}>
            <Header as="h4" inverted>
              Don&apos;t waste your life on the Internet!{' '}
            </Header>
            <p>Copyright &copy; TribeVibe</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>
);

export default FooterBlock;



// WEBPACK FOOTER //
// ./src/components/FooterBlock.js